import * as React from 'react';

import CampaignTimelineOverviewStep from '../../step/CampaignTimelineOverviewStep';

import { __t, applyTranslations } from 'utils/language';
import { getDisplayDate, getDisplayDateNoYear } from 'utils/date';

import './campaign-timeline-overview.scss';

applyTranslations(require('./campaign-timeline-overview.i18n.json'));

import { CcmCampaignTimeline } from '../../../../ccm/types/CcmCampaignTimeline.type';

type Props = {
  timeline: CcmCampaignTimeline | null | undefined
};

const MSG_KEY = 'campaign_timeline_overview';

const CampaignTimelineOverview: React.FC<Props> = ({
  timeline
}): JSX.Element => (
  <div className="campaign-timeline-overview">
    <CampaignTimelineOverviewStep
      type="initial-tick"
      text={__t(`${MSG_KEY}.steps.initial`)}
    />
    <CampaignTimelineOverviewStep
      type="common"
      text={__t(`${MSG_KEY}.steps.one`)}
      value="1"
      date={`${__t(`${MSG_KEY}.until`)} ${getDisplayDate(timeline?.moderatorsApproveUntil)}`}
    />
    <CampaignTimelineOverviewStep
      type="common"
      text={__t(`${MSG_KEY}.steps.two`)}
      value="2"
      date={`${__t(`${MSG_KEY}.from`)} ${getDisplayDate(timeline?.influencersSignInStartDate)}`}
    />
    <CampaignTimelineOverviewStep
      type="common"
      text={__t(`${MSG_KEY}.steps.three`)}
      value="3"
      date={`
          ${getDisplayDateNoYear(timeline?.influencersSubmitOutfitsFrom)} -
          ${getDisplayDate(timeline?.influencersSubmitOutfitsUntil)}
        `}
    />
    <CampaignTimelineOverviewStep
      type="common"
      text={__t(`${MSG_KEY}.steps.four`)}
      value="4"
      date={`${__t(`${MSG_KEY}.from`)} ${getDisplayDate(timeline?.taskContentGoLiveDate)}`}
    />
    <CampaignTimelineOverviewStep
      type="final"
      text={__t(`${MSG_KEY}.steps.final`)}
      value="5"
      date={getDisplayDate(timeline?.campaignEndDate)}
    />
  </div>
);

export default CampaignTimelineOverview;
